/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LogisticsInputs */

const en_nav_logistics = /** @type {(inputs: Nav_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics`)
};

const es_nav_logistics = /** @type {(inputs: Nav_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistica`)
};

/**
* | output |
* | --- |
* | "Logistics" |
*
* @param {Nav_LogisticsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_logistics = /** @type {((inputs?: Nav_LogisticsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LogisticsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_logistics(inputs)
	return es_nav_logistics(inputs)
});